import { ApiGetRequest } from './api-get-request';
import { ApiParameters } from './api-parameters';

export class MyTicketRequest extends ApiGetRequest
{
    public constructor(webapiBasepath: string)
    {
        super(
            'myticket/get',
            new ApiParameters(),
            null,
            webapiBasepath);
    }
}
